import {Deserializable} from './deserializable.model';

export class MyobServicePaymentInvoice implements Deserializable {
// Myob Service Invoice Payment Model

public UID!: string;
public DepositTo?: string;
public Account?: Account;
public Customer?: Customer;
public ReceiptNumber?: string;
public Date?: Date;
public AmountReceived?: number;
public AmountReceivedForeign?: any;
public PaymentMethod?: string;
public Memo?: string;
public Invoices?: Invoice[];
public TransactionID?: any;
public ForeignCurrency?: any;
public CurrencyExchangeRate?: any;
public URI?: string;
public RowVersion?: string;

  deserialize(input: any): this {
    // Assign input to our object BEFORE deserialize our cars to prevent already deserialized cars from being overwritten.
    Object.assign(this, input);

    // Iterate over all cars for our user and map them to a proper `Car` model
    //  this.cars = input.cars.map(car => new Car().deserialize(car));

       // Iterate over all addresses for our myob_conntact and map them to a proper `Address` model
    // this.Addresses = input.Addresses.map(address => new Address().deserialize(address));

    return this;
  }
  
//   getFullName() {
//     return this.FirstName + ' ' + this.LastName;
//   }



}

export interface Account {
    UID: string;
    Name: string;
    DisplayID: string;
    URI: string;
}

export interface Customer {
    UID: string;
    Name: string;
    DisplayID: string;
    URI: string;
}

export interface Invoice {
    RowID: number;
    Number: string;
    UID: string;
    AmountApplied: number;
    AmountAppliedForeign?: any;
    Type: string;
    URI: string;
}





  /*
  * convert the JOSIN results of an API to any Model/Class/Interface Struction
  * @source: http://json2ts.com/
  */  